import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PaymentsBlockComponent from "./payments_table_block";
import PaymentAddBlockComponent from "./payments_add_block";
import Axios from "axios";
import {
  postPayment,
  updatePayment,
  deletePayment,
  editPayment,
  getWaitingPayments,
  createWaitingPayment,
  resendWaitingPayment,
  removeWaitingPayment,
} from "../../../../../../redux/Actions/paymentAction";
import { connect } from "react-redux";
import {
  antdMessageError,
  getDateFormat,
  prettyDateFormat,
  returnEuroString,
  toFixedNumber,
} from "../../../../../../helpers/Utils";
import TextInputModal from "../../../../TextInputModal";
import { BlueButton, FlopppyButton } from "../../../../ButtonWithLoading";
import { Tooltip, message, Modal } from "antd";
import { IoIosMail, IoIosRefreshCircle } from "react-icons/io";
import { CheckBoxInput, SelectForm } from "../../../../Buttons";
import { GoPrimitiveDot } from "react-icons/go";
import InputSwitchComponent from "../../../../InputSwitchComponent";
import DataPickerInputModal from "../../../../DataPickerInputModal";
import { IconDelete, IconDot, IconExclamation, IconRollBack } from "../../../../../Layout/Icons";
import {
  postMoneyRefunds,
  removeMoneyRefunds,
} from "../../../../../../redux/Actions/money_refunds_action";
import { bank_options } from "../../../../../../helpers/GlobalOptions";
import MoneyRefundOrderRowPreview from "./MoneyRefundOrderRowPreview";
import { onChangeNumber } from "../../../../../../helpers/Input";
import AntdConfirm from "../../../../../../helpers/AntdConfirm";
import MoneyRefundOrderCartRulesPreview from "./MoneyRefundOrderCartRulesPreview";
import { SelectableMenu } from "../../../../../globals";
import { paymentDetailsAutoFill } from "../../../../../../helpers/order";

function PaymentBlockComponent({
  payments_col,
  orderId,
  payments_add_col,
  payment,
  payments,
  goodsAddRowClick,
  editPayment,
  postPayment,
  updatePayment,
  deletePayment,
  total_price,
  paymentBlock,
  money_refund_items,
  order,
}) {
  const dispatch = useDispatch();
  const [type, setType] = useState("send_letter");
  const [paymentTypes, setPaymentTypes] = useState([]);

  useEffect(() => {
    if (!orderId) return;
    if (paymentTypes.length == 0) {
      Axios.get(`/api/v1/orders/${orderId}/payments/payment_types`).then(
        (res) => {
          const newArray = res.data.map((item) => {
            return {
              value: item[1],
              label: item[0],
            };
          });
          setPaymentTypes(newArray);
        }
      );
    }
    dispatch(getWaitingPayments(orderId));
  }, [orderId]);

  return (
    <React.Fragment>
      <div className="table-responsive bg-silver pt-2">
        <div
          className="col-12"
          style={{
            marginBottom: "1rem",
          }}
        >
          {payments_col == "refunds" ? (
            <MoneyReturnTemplate money_refund_items={money_refund_items} />
          ) : (
            <>
              <PaymentTemplate
                payments={payments}
                total_price={total_price}
                payment={payment}
                orderId={orderId}
                goodsAddRowClick={goodsAddRowClick}
                paymentTypes={paymentTypes}
                deletePayment={deletePayment}
              />
            </>
          )}
          {payments_add_col && (
            <React.Fragment>
              <hr />
              <PaymentAddBlockComponent
                orderId={orderId}
                paymentTypes={paymentTypes}
                postPayment={postPayment}
                updatePayment={updatePayment}
                payments={payments}
                editPayment={editPayment}
                goodsAddRowClick={goodsAddRowClick}
                total_price={total_price}
                payment={payment}
                paymentBlock={paymentBlock}
              />
            </React.Fragment>
          )}
          <PendingPayments orderId={orderId} />
          <InputSwitchComponent
            options={[
              {
                label: "Send a letter for payment",
                value: "send_letter",
              },
              {
                label: "Refund",
                value: "refund",
              },
            ]}
            value={type}
            onChange={(val) => setType(val.target.value)}
          />
          {type == "send_letter" ? (
            <EmailSendRender orderId={orderId} />
          ) : (
            <OrderRefundMoney
              order={order}
              order_id={orderId}
              payments={payments}
              money_refund_items={money_refund_items}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  payments: state.orders.payments,
  payment: state.orders.payment,
});
export default connect(mapStateToProps, {
  postPayment,
  updatePayment,
  deletePayment,
  editPayment,
})(PaymentBlockComponent);

const MoneyReturnTemplate = ({ money_refund_items }) => {
  const dispatch = useDispatch();
  const role_identifier = useSelector((state) => state.auth.user.role);
  const role_accounting = "accounting" == role_identifier;

  const total_sum = useMemo(
    () =>
      returnEuroString(
        money_refund_items.reduce(
          (total, acc) => (acc.status ? +acc.sum + total : total),
          0
        )
      ),
    [money_refund_items.length]
  );
  return (
    <table
      className="table table-sm mb-0"
      style={{ marginBottom: "0px!important" }}
    >
      <thead className="border-bottom mb-1">
        <tr>
          <th className="text-black">Status</th>
          <th className="text-black w-33">User</th>
          <th className="text-black w-33">Bank acc. no.</th>
          <th className="text-black w-33">Reason</th>
          <th className="text-black w-33">Date</th>
          <th className="text-black">Sum</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {money_refund_items.map((d) => (
          <React.Fragment key={d.id}>
            <tr>
              <td
                className="align-middle text-center"
                style={{ fontSize: "0.8rem" }}
              >
                <IconDot
                  className={d.status ? "text-success" : "text-danger"}
                />
              </td>
              <td>{d.user_full}</td>
              <td>{d.bank_account}</td>
              <td>{d.reason}</td>
              <td>{d.date}</td>
              <td className="text-danger">-{d.sum}</td>
              <td>
                {role_accounting && !d.status && (
                  <div
                    className="text-decoration-underline text-silver cursor-pointer"
                    onClick={() => {
                      if (!confirm("Are you sure?")) return;
                      dispatch(removeMoneyRefunds(d.id));
                    }}
                  >
                    Cancel
                  </div>
                )}
              </td>
            </tr>
            <tr>
              <td colSpan={7}>
                <div className="bg-light-primary rounded">
                  <MoneyRefundOrderRowPreview o_rows={d.order_row_items} />
                </div>
              </td>
            </tr>
          </React.Fragment>
        ))}
        <tr className="border-top mt-1">
          <td colSpan="4">Total paid:</td>
          <td colSpan="2">
            <div className="text-danger">-{total_sum}</div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const PaymentTemplate = ({
  payments,
  total_price,
  payment,
  orderId,
  goodsAddRowClick,
  paymentTypes,
  deletePayment,
}) => {
  total_price = toFixedNumber(total_price);

  const dangerColor = () => {
    const total = toFixedNumber(
      payments.reduce((acc, cur) => +acc + +cur.price, 0)
    );
    const totalPrice = total_price;
    if (+totalPrice == +total) {
      return <span className="font-weight-bold text-black">{total}</span>;
    }
    return <span className="font-weight-bold text-danger">{total}</span>;
  };

  return (
    <table
      className="table table-sm mb-0"
      style={{ marginBottom: "0px!important" }}
    >
      <thead className="border-bottom mb-1">
        <tr>
          <th className="text-black">No.</th>
          <th className="text-black w-33">Method of payment</th>
          <th className="text-black w-33">User</th>
          <th className="text-black w-33">Date</th>
          <th className="text-black">Sum</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {payments.map((paymentVal, index) => (
          <PaymentsBlockComponent
            key={index}
            payment={paymentVal}
            paymentEdit={payment}
            orderId={orderId}
            paymentTypes={paymentTypes}
            // updatePayment={updatePayment}
            goodsAddRowClick={goodsAddRowClick}
            deletePayment={deletePayment}
            editPayment={editPayment}
          />
        ))}
        <tr className="border-top mt-1">
          <td colSpan="4">Total paid:</td>
          <td colSpan="3">{dangerColor()}</td>
        </tr>
      </tbody>
    </table>
  );
};

const PendingPayments = ({ orderId }) => {
  const dispatch = useDispatch();
  const waiting_payments = useSelector(
    (state) => state.orders.order.waiting_payments
  );
  const resendWaitingPaymentComponent = (id) => {
    dispatch(resendWaitingPayment(orderId, id)).then((response) => {
      if (response.success) {
        message.success("Payment resent");
      } else {
        message.error("Error occurred");
      }
    });
  };

  return (
    <div className="mb-3">
      <hr className="mt-1 mb-1" />
      {waiting_payments.length == 0 ? (
        "No pending payments"
      ) : (
        <table
          className="table table-sm mb-0"
          style={{ marginBottom: "0px!important" }}
        >
          <thead className="border-bottom mb-1">
            <tr>
              <th className="text-black">Service or good</th>
              <th className="text-black w-33">Sum</th>
              <th className="text-black">COD</th>
              <th className="text-black w-33">Sending Date</th>
              <th className="text-black w-33">Payment Date</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {waiting_payments.map((payment, index) => (
              <tr key={index}>
                <td>{payment.service}</td>
                <td>{Number(payment.price).toFixed(2)} €</td>
                <td>
                  <GoPrimitiveDot
                    className={payment.cod ? "text-success" : "text-danger"}
                  />
                </td>
                <td>{prettyDateFormat(payment.created_at)}</td>
                <td>
                  {payment.created_at !== payment.updated_at &&
                    prettyDateFormat(payment.updated_at)}
                </td>
                <td>
                  {payment.status == "unpaid"
                    ? "Unpaid"
                    : payment.status == "paid_temp"
                      ? "Payment initiated"
                      : "Paid"}
                </td>
                <td>
                  {payment.status == "unpaid" ? (
                    <>
                      <Tooltip title="Resend" placement="left">
                        <div
                          onClick={() =>
                            resendWaitingPaymentComponent(payment.id)
                          }
                        >
                          <IoIosRefreshCircle
                            color={"#8678AB"}
                            style={{ cursor: "pointer" }}
                            size={20}
                          />
                        </div>
                      </Tooltip>
                      <div>
                        <Tooltip title="Remove" placement="left">
                          <IconDelete
                            className="cursor-pointer mt-2 ml-1"
                            onClick={() => {
                              AntdConfirm({
                                onOk: () => {
                                  dispatch(
                                    removeWaitingPayment(orderId, payment.id)
                                  );
                                  console.log("ok11");
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </>
                  ) : (
                    <div className="text-success">OK</div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const EmailSendRender = ({ orderId }) => {
  const dispatch = useDispatch();
  const [service, setService] = useState("");
  const [price, setPrice] = useState(0);
  const [cod, setCod] = useState(false);
  const [errors, setErrors] = useState({});

  const [creatingWaitingPayment, setCreatingWaitingPayment] = useState(false);

  const createWaitingPaymentComponent = () => {
    setCreatingWaitingPayment(true);

    dispatch(createWaitingPayment(orderId, service, price, cod)).then(
      (response) => {
        if (response.success) {
          message.success("Payment added");
          setService("");
          setPrice(0);
          setCod(false);
          setErrors({});
          setCreatingWaitingPayment(false);
        } else {
          message.error("Error occurred");
          setErrors(response.errors);
          setCreatingWaitingPayment(false);
        }
      }
    );
  };
  return (
    <>
      <p className="bg-silver d-flex mb-1 mt-3">Send a letter for payment</p>
      <div className="d-flex">
        <div className="w-50 mr-2">
          <TextInputModal
            type="text"
            text="Product or service"
            placeholder="Enter"
            name="[payment_auto]service"
            value={service}
            onChange={(e) => setService(e.target.value)}
            error={errors.service}
            required={true}
          />
        </div>
        <div className="w-50">
          <div className="d-flex justify-content-between">
            <div>
              <TextInputModal
                type="number"
                text="Sum"
                placeholder="Enter"
                name="[payment_auto]price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                error={errors.price}
                required={true}
              />
            </div>

            <div className="ml-3">
              <div className="text-bold my-1">COD</div>

              <CheckBoxInput checked={cod} onChange={() => setCod(!cod)} />
            </div>

            <div className="ml-3">
              <div className="text-bold my-1 invisible">Save</div>

              <FlopppyButton
                className="p-0"
                loading={creatingWaitingPayment}
                onClick={() => createWaitingPaymentComponent()}
              >
                <IoIosMail color={"#fff"} size={20} />
              </FlopppyButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const buildInitialState = () => ({
  date: "",
  reason: "",
  bank_account: "",
  bank_name: "Swedbank",
  sum: "",
  order_rows: [],
  total_product: "",
  order_cart_rules: [],
  total_discount: "",
  customer: "",
});
const OrderRefundMoney = ({
  order_id,
  payments,
  money_refund_items,
  order,
}) => {
  //   Paskutinis step
  const dispatch = useDispatch();
  const role_identifier = useSelector((state) => state.auth.user.role);
  const isAdmin = role_identifier === "admin";
  const o_rows = useSelector((state) => state.orders.order_rows);
  let o_cart_rules = useSelector((state) => state.orders.order_cart_rules);
  o_cart_rules = o_cart_rules === undefined ? [] : o_cart_rules;
  const { total_shipping_tax_incl, billing_address, order_shop_id } =
    useSelector((state) => state.orders.order);
  const shipments = useSelector((state) => state.orders.shipments);

  // states

  const manual_cart_items = order?.order_cart_rules?.filter(
    (item) => item.id_product === null || item.identifier === "manual_cart"
  );
  // const total_discount = manual_cart_items?.reduce(
  //   (sum, item) => sum + parseFloat(item.total),
  //   0
  // );
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("products");
  const [variables, setVariables] = useState(buildInitialState);
  const [errors, setErrors] = useState({});
  const dateRef = useRef(null);

  useEffect(() => {
    const details = paymentDetailsAutoFill({
      payments,
      billing_address,
    });
    onChange("customer", details.customer);
    onChange("bank_account", details.bank_account);
  }, [payments.length]);

  useEffect(() => {
    onChange("sum", +variables.total_product - +variables.total_discount);
  }, [variables.total_discount, variables.total_product]);

  // useEffect(() => {
  //   onChange("total_discount", total_discount);
  // }, [total_discount]);

  const order_cart_rules = useMemo(() => {
    const filtered = o_cart_rules.filter(({ id_product }) => !id_product);
    if (!money_refund_items.length || type !== "products")
      return {
        available: filtered,
      };

    const used_order_rows_success = money_refund_items
      .filter((d) => d.status)
      .map((d) => d.order_cart_rules)
      .flat();

    const used_order_rows_waiting = money_refund_items
      .filter((d) => !d.status)
      .map((d) => d.order_cart_rules)
      .flat();

    const used_success = filtered.filter((d) =>
      used_order_rows_success.includes(d.id)
    );
    const used_waiting = filtered.filter((d) =>
      used_order_rows_waiting.includes(d.id)
    );
    const available = isAdmin
      ? filtered
      : filtered.filter(
        (d) =>
          ![...used_order_rows_success, ...used_order_rows_waiting].includes(
            d.id
          )
      );

    return {
      used_success,
      used_waiting,
      available,
    };
  }, [o_cart_rules, money_refund_items, money_refund_items?.length, type, isAdmin]);

  const order_rows = useMemo(() => {
    const source_rows = Array.isArray(o_rows)
      ? o_rows.filter((row) => row?.ui_row_key !== "delivery_available")
      : [];

    if (!money_refund_items.length || type !== "products")
      return {
        available: +total_shipping_tax_incl
          ? [
            {
              unit_price_tax_incl: +total_shipping_tax_incl,
              product_name: "Delivery",
              id: "delivery",
              ui_row_key: "delivery_available",
              quantity: 1,
            },
            ...source_rows,
          ]
          : source_rows,
      };
    const used_order_rows_success = money_refund_items
      .filter((d) => d.status)
      .map((d) => d.order_rows)
      .flat();

    const used_order_rows_waiting = money_refund_items
      .filter((d) => !d.status)
      .map((d) => d.order_rows)
      .flat();

    const used_success = source_rows.filter((d) =>
      used_order_rows_success.includes(d.id)
    );
    const used_waiting = source_rows.filter((d) =>
      used_order_rows_waiting.includes(d.id)
    );
    const available = isAdmin
      ? [...source_rows]
      : source_rows.filter(
        (d) =>
          ![...used_order_rows_success, ...used_order_rows_waiting].includes(
            d.id
          )
      );

    // Shiping price settings
    const shiping_used =
      money_refund_items.length > 0 &&
      money_refund_items.some((d) => d.shipping > 0);

    // console.log(total_shipping_tax_incl, shiping_used);
    if (+total_shipping_tax_incl || shiping_used) {
      if (shiping_used) {
        money_refund_items
          .filter((d) => d.shipping > 0)
          .forEach((d) => {
            const service_shiping = {
              unit_price_tax_incl: d.shipping,
              product_name: "Delivery",
              id: "delivery",
              ui_row_key: `delivery_${d.id}_${d.status ? "success" : "waiting"}`,
              quantity: 1,
            };
            if (d.status) {
              used_success.push(service_shiping);
            } else {
              used_waiting.push(service_shiping);
            }
          });
      }
      if ((!shiping_used || isAdmin) && +total_shipping_tax_incl) {
        const has_available_delivery = available.some(
          (row) => row?.ui_row_key === "delivery_available"
        );
        const service_shiping = {
          unit_price_tax_incl: total_shipping_tax_incl,
          product_name: "Delivery",
          id: "delivery",
          ui_row_key: "delivery_available",
          quantity: 1,
        };
        if (!has_available_delivery) {
          available.push(service_shiping);
        }
      }
    }
    return {
      used_success,
      used_waiting,
      available,
    };
  }, [
    o_rows,
    money_refund_items,
    money_refund_items?.length,
    type,
    isAdmin,
    total_shipping_tax_incl,
  ]);

  const selected_all_available = useMemo(() => {
    if (!order_rows?.available?.length) return false;
    return order_rows.available.every((d) =>
      variables.order_rows.includes(d.id)
    );
  }, [variables.order_rows, order_rows]);

  const totalAlreadyRefunded = useMemo(() => {
    if (!money_refund_items?.length) return 0;
    return money_refund_items.reduce((total, item) => total + (+item.sum || 0), 0);
  }, [money_refund_items, money_refund_items?.length]);

  const orderTotal = useMemo(() => +order?.total_price || 0, [order?.total_price]);
  const totalPaid = useMemo(() => payments.reduce((acc, cur) => +acc + +cur.price, 0), [payments]);
  const codPaid = useMemo(() => {
    if (!order?.cod) return 0;
    return order?.status?.id_status === 1 ? orderTotal : 0;
  }, [order?.cod, order?.status?.id_status, orderTotal]);
  const leasingPaid = useMemo(() => {
    if (!order?.is_leasing_approved) return 0;
    return orderTotal;
  }, [order?.is_leasing_approved, orderTotal]);
  const effectivePaid = useMemo(() => Math.max(totalPaid, codPaid, leasingPaid), [totalPaid, codPaid, leasingPaid]);
  const maxRefundable = useMemo(() => Math.max(0, Math.max(orderTotal, totalPaid) - totalAlreadyRefunded), [orderTotal, totalPaid, totalAlreadyRefunded]);
  const maxPaidRefundable = useMemo(() => Math.max(0, effectivePaid - totalAlreadyRefunded), [effectivePaid, totalAlreadyRefunded]);
  const isRefundExceeding = !isAdmin && +parseFloat(+variables.sum).toFixed(4) > +parseFloat(maxRefundable).toFixed(4);
  const isRefundExceedingPaid = +parseFloat(+variables.sum).toFixed(4) > +parseFloat(maxPaidRefundable).toFixed(4);

  const onChange = (name, value) => {
    setVariables((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getSelectedRowsWithActiveShipments = () => {
    if (type !== "products") return [];
    const selectedIds = variables.order_rows.filter((id) => id !== "delivery");
    if (!selectedIds.length) return [];

    const orderRowIdsWithActiveShipments = new Set();
    shipments?.forEach((shipment) => {
      shipment.shipment_order_rows?.forEach((sor) => {
        if (!sor.canceled_at && !sor.deleted_at && selectedIds.includes(sor.order_row_id)) {
          orderRowIdsWithActiveShipments.add(sor.order_row_id);
        }
      });
    });

    return o_rows.filter((row) => orderRowIdsWithActiveShipments.has(row.id));
  };

  const performRefund = async () => {
    try {
      setLoading(true);
      const {
        date,
        bank_name,
        bank_account,
        reason,
        sum,
        order_rows,
        order_cart_rules,
        customer,
        total_discount,
        total_product,
      } = variables;
      if (!date) {
        setErrors((prev) => ({ ...prev, buy_date: "Choose date" }));
        dateRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        return antdMessageError("Choise date");
      }
      if (!bank_name) return antdMessageError("Choise bank");
      if (+sum <= 0 && order_cart_rules.length > 0)
        return antdMessageError(
          "[Total amount]: It cannot be less than or equal to 0"
        );
      if (!isAdmin && +parseFloat(+sum).toFixed(4) > +parseFloat(maxRefundable).toFixed(4))
        return antdMessageError(
          `Refund amount (${(+sum).toFixed(2)}€) exceeds the maximum refundable amount (${maxRefundable.toFixed(2)}€). Order total: ${orderTotal.toFixed(2)}€, total paid: ${totalPaid.toFixed(2)}€, already refunded: ${totalAlreadyRefunded.toFixed(2)}€`
        );
      if (+parseFloat(+sum).toFixed(4) > +parseFloat(maxPaidRefundable).toFixed(4))
        return antdMessageError(
          `Refund amount (${(+sum).toFixed(2)}€) exceeds the amount the client actually paid (${maxPaidRefundable.toFixed(2)}€ left). Total paid: ${effectivePaid.toFixed(2)}€, already refunded: ${totalAlreadyRefunded.toFixed(2)}€`
        );
      const params = {
        date,
        bank_name,
        order_shop_id,
        money_refund_item: {
          reason,
          sum,
          order_rows: order_rows.filter(
            (order_row) => order_row !== "delivery"
          ),
          shipping: order_rows.find((order_row) => order_row == "delivery")
            ? total_shipping_tax_incl || 0
            : 0,
          total_discount,
          total_product,
          order_cart_rules,
          bank_account: bank_account.toUpperCase(),
          order_id,
          customer,
          refund_type: type,
        },
      };
      if (type !== "products") {
        params.money_refund_item.order_rows = [];
      }

      const { success, errors } = await dispatch(postMoneyRefunds(params));
      if (!success && errors) setErrors(errors);
      if (success) {
        setErrors({});
        setVariables((prev) => ({
          ...buildInitialState(),
          date: prev.date,
          bank_name: prev.bank_name,
          bank_account: prev.bank_account,
          customer: prev.customer,
        }));
      }
    } catch (er) {
      console.log("ERROR: ", er);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = () => {
    const rowsWithActiveShipments = getSelectedRowsWithActiveShipments();
    if (rowsWithActiveShipments.length > 0) {
      Modal.confirm({
        title: "Products with active shipments",
        icon: <IconExclamation className="text-orange" />,
        width: 520,
        content: (
          <div>
            <p>
              The following products have active (not canceled) shipments. Are
              you sure you want to make a refund?
            </p>
            <div style={{ maxHeight: 300, overflowY: "auto" }}>
              {rowsWithActiveShipments.map((row) => (
                <div
                  key={row.id}
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    padding: "8px 0",
                  }}
                >
                  <div>
                    <b>{row.product_reference}</b>
                  </div>
                  <div>{row.product_name}</div>
                  <div>
                    Qty: {row.quantity} |{" "}
                    {returnEuroString(row.unit_price_tax_incl)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ),
        okText: "Yes, refund",
        cancelText: "Cancel",
        onOk: () => performRefund(),
      });
    } else {
      performRefund();
    }
  };

  return (
    <div>
      <div className="d-flex">
        <div className="mr-2 w-50" ref={dateRef}>
          <DataPickerInputModal
            required={true}
            text="Return date"
            name="buy_date"
            value={getDateFormat(variables.date)}
            onChange={(_, r) => {
              onChange("date", r);
              setErrors((prev) => ({ ...prev, buy_date: undefined }));
            }}
            warning={errors.buy_date}
          />
        </div>
        <div className="w-50">
          <SelectForm
            required={true}
            placeholder="Bank"
            dropdownMatchSelectWidth={false}
            options={bank_options}
            onChange={(r) => onChange("bank_name", r)}
            value={variables.bank_name || undefined}
            error={errors.bank_name}
          />
        </div>
      </div>
      <div className="d-flex">
        <div className="mr-2 w-50">
          <TextInputModal
            required={true}
            text="Customer"
            value={variables.customer}
            onChange={(e) => onChange("customer", e.target.value)}
            warning={errors.customer}
          />
        </div>
        <div className="w-50">
          <TextInputModal
            text="Reason"
            value={variables.reason}
            onChange={(e) => onChange("reason", e.target.value)}
            warning={errors.reason}
          />
        </div>
      </div>

      <SelectableMenu
        options={[
          { label: "Products", value: "products" },
          { label: "Compensation", value: "compensation" },
        ]}
        value={type}
        setValue={setType}
      />
      {type == "products" && (
        <>
          <div className="text-bold my-1 ">
            Products <span className="orange_color">*</span>
          </div>
          <div className="bg-light-primary rounded">
            <MoneyRefundOrderRowPreview
              order_cart_rules={o_cart_rules}
              o_rows={order_rows.available}
              order_rows_selected={variables.order_rows}
              setValue={(val) => {
                onChange("total_product", val.sum);
                onChange("order_rows", val.order_rows);
              }}
            />
          </div>
          {errors.order_rows && (
            <div className="text-danger">{errors.order_rows}</div>
          )}

          <div className="text-bold my-1 ">
            Refund applied <span className="orange_color">*</span>
          </div>
          <div className="bg-light-primary rounded">
            <MoneyRefundOrderRowPreview
              order_cart_rules={o_cart_rules}
              type="success"
              o_rows={order_rows?.used_success}
              order_rows_selected={variables.order_rows}
            />
            <MoneyRefundOrderRowPreview
              order_cart_rules={o_cart_rules}
              type="waiting"
              o_rows={order_rows?.used_waiting}
              order_rows_selected={variables.order_rows}
            />
          </div>
          {o_cart_rules.length > 0 && (
            <>
              <div className="text-bold my-1 ">
                Discounts <span className="orange_color">*</span>
              </div>
              <div className="bg-light-primary rounded">
                <MoneyRefundOrderCartRulesPreview
                  order_cart_rules={order_cart_rules.available}
                  order_cart_rules_selected={variables.order_cart_rules}
                  setValue={(val) => {
                    console.log({ val });
                    onChange("total_discount", val.sum);
                    onChange("order_cart_rules", val.order_cart_rules);
                  }}
                />
              </div>
              <div className="text-bold my-1 ">
                Refund applied <span className="orange_color">*</span>
              </div>
              <div className="bg-light-primary rounded">
                <MoneyRefundOrderCartRulesPreview
                  type="success"
                  order_cart_rules={order_cart_rules?.used_success}
                  order_cart_rules_selected={variables.order_cart_rules}
                />
                <MoneyRefundOrderCartRulesPreview
                  type="waiting"
                  order_cart_rules={order_cart_rules?.used_waiting}
                  order_cart_rules_selected={variables.order_cart_rules}
                />
              </div>
            </>
          )}
        </>
      )}

      <div className="d-flex justify-content-between align-items-center">
        <div
          style={{
            width: "33%",
          }}
        >
          <TextInputModal
            suffix="€"
            required={true}
            text="Total product/service"
            value={variables.total_product}
            onChange={(e) => {
              const value = onChangeNumber(e);
              onChange("total_product", value.target.value);
            }}
            warning={errors.total_product}
          />
        </div>
        <div
          className="mx-2"
          style={{
            width: "33%",
          }}
        >
          <TextInputModal
            suffix="€"
            text="Total discount"
            value={variables.total_discount}
            onChange={(e) => {
              const value = onChangeNumber(e);
              onChange("total_discount", value.target.value);
            }}
            warning={errors.total_discount}
          />
        </div>
        <div
          style={{
            width: "33%",
          }}
        >
          <TextInputModal
            disabled={true}
            suffix="€"
            text={<span>Total Amount {!isAdmin && <span style={{ fontSize: '10px', fontWeight: 'normal', color: '#999' }}>(max: {maxRefundable.toFixed(2)}€)</span>}</span>}
            value={variables.sum}
          />
        </div>
      </div>
      {isRefundExceeding && (
        <div style={{ color: '#ff4d4f', fontSize: '12px', fontWeight: 500, marginTop: 4, marginBottom: 4 }}>
          Refund amount ({(+variables.sum).toFixed(2)}€) exceeds the maximum refundable amount ({maxRefundable.toFixed(2)}€)
        </div>
      )}
      <div className="d-flex justify-content-between align-items-end">
        <div
          style={{
            width: "33%",
          }}
        >
          <TextInputModal
            required={true}
            text="Bank account number"
            value={variables.bank_account}
            onChange={(e) => onChange("bank_account", e.target.value)}
            warning={errors.bank_account}
          />
        </div>

        {type == "products" && (
          <div
            className="mx-2"
            style={{
              width: "33%",
            }}
          >
            <div className="text-bold">Not returned</div>
            <div className="mt-2">
              <CheckBoxInput
                checked={selected_all_available}
                onChange={() => {
                  if (selected_all_available) {
                    onChange("total_product", 0);
                    onChange("order_rows", []);
                    onChange("total_discount", 0);
                    onChange("order_cart_rules", []);
                    return;
                  }

                  const or = order_rows.available.map((d) => d.id);
                  const sum = order_rows.available.reduce(
                    (total, cur) =>
                      +cur.unit_price_tax_incl * Number(cur.quantity || 0) +
                      total,
                    0
                  );

                  const discount_ids = order_cart_rules.available.map((d) => d.id);
                  const discount_sum = order_cart_rules.available.reduce(
                    (total, cur) => +cur.total + total,
                    0
                  );

                  onChange("total_product", sum);
                  onChange("order_rows", or);
                  onChange("total_discount", discount_sum);
                  onChange("order_cart_rules", discount_ids);
                }}
              />
            </div>
          </div>
        )}
        <div
          className="d-flex justify-content-end"
          style={{
            width: "33%",
          }}
        >
          <BlueButton loading={loading} onClick={onSubmit} disabled={isRefundExceeding || isRefundExceedingPaid}>
            <IconRollBack /> Refund
          </BlueButton>
          {isRefundExceedingPaid && (
            <div style={{ color: '#ff4d4f', fontSize: '12px', fontWeight: 500, marginTop: 4 }}>
              Refund amount ({(+variables.sum).toFixed(2)}€) exceeds the amount the client actually paid ({maxPaidRefundable.toFixed(2)}€ left)
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
